import React from "react";

import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography
} from "@mui/material";

import { Trans } from "@lingui/macro";
import { ProfileTableProps } from "./models";

export class ProfileTable extends React.Component<ProfileTableProps, {}>
{
	render()
	{
		return (<Table>
      <TableBody>
        <TableRow>
          <TableCell sx={{border: 0, width: "200px"}}>
            <Typography variant="h3" sx={{color: "#FFFFFF", fontSize: "20px", textTransform: "uppercase", textAlign: "center", background: process.env.REACT_APP_PRIMARY_COLOR}}><Trans id="pt-table-cell-profile">Dati profilo</Trans></Typography>
          </TableCell>
          <TableCell sx={{border: 0, width: "300px"}}/>
          <TableCell sx={{border: 0, width: "500px"}}>
            <Typography variant="h3" sx={{color: "#FFFFFF"}}><Trans id="pt-table-cell-user">Utente</Trans></Typography>
          </TableCell>
          <TableCell sx={{border: 0}}>
            <Typography variant="body2" sx={{color: "#D9D9D9"}}>{this.props.user.name}</Typography>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{border: 0, width: "200px"}}/>
          <TableCell sx={{border: 0, width: "300px"}}/>
          <TableCell sx={{border: 0, width: "500px"}}>
            <Typography variant="h3" sx={{color: "#FFFFFF"}}><Trans id="pt-table-cell-email">Email</Trans></Typography>
          </TableCell>
          <TableCell sx={{border: 0}}>
            <Typography variant="body2" sx={{color: "#D9D9D9"}}>{this.props.user.email}</Typography>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{border: 0}}/>
          <TableCell sx={{border: 0}}/>
          <TableCell sx={{border: 0}}>
            <Button variant="contained"
              color={"secondary"}
              size={"small"}
              type="submit">
              <Trans id="pt-delete-user-button">Cencella utenza</Trans>
            </Button>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>)
	}
}
